import { IPm } from 'APIPackage/KnmModule/interfaces/IPm';

import { IKnmRequirementsNpa } from '../../../APIPackage/KnmModule/interfaces/IKnmRequirementsNpa';
import { IKnmPmFormRequirementsNpa } from '../interfaces/IKnmPmFormRequirementsNpa';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';

export const convertRequirementsNpaFormValueToKnmData = (
  requirements: IKnmPmFormRequirementsNpa[] | undefined,
): IPm['requirements'] => {
  return (
    requirements?.map(item => {
      const { npa, structuralUnit, mandatory, inspectionResults } = item;
      const newItem: IKnmRequirementsNpa = {
        npaId: npa.id,
        number: npa.number || null,
        title: npa.title || null,
        acceptanceDate: formatDate({
          date: npa.acceptanceDate ?? '',
          dateFormat: SYSTEM_DATE_FORMAT_FNS,
          parseFormat: DATE_FORMAT_LONG_FNS,
        }),
        structuralUnit: {
          id: structuralUnit.id,
          title: structuralUnit.title || null,
          mandatoryRequirements: mandatory
            ? mandatory.map(mandatoryItem => ({
                id: mandatoryItem.id,
                title: mandatoryItem.title,
              }))
            : null,
        },
        inspectionResults,
        isFilledFromLink: item.isFilledFromLink || null,
      };

      return newItem;
    }) || null
  );
};
